// extracted by mini-css-extract-plugin
export default {"Emoji":"bbw_a bhy_i bhy_q bhy_j"};